import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlidadeConfigModel } from '../../../core/services/models/alidade-config.model';

@Injectable({
  providedIn: 'root',
})
export class EmbeddedFieldsService {
  private readonly apiUrl: string;

  constructor(
    @Inject('ALIDADE_CONFIG') config: AlidadeConfigModel,
    private http: HttpClient,
  ) {
    this.apiUrl = `${config.apiURL}/builder`;
  }

  removeEmbeddedFieldFromSurvey(embeddedFieldId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/embeddedFields/${embeddedFieldId}`);
  }

  /* embedded field choice*/
  createEmbeddedField(
    surveyVersionId: number,
    choiceName: string,
    choiceType: number,
    choiceValue: string | number | boolean | null,
  ): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/versions/${surveyVersionId}/embeddedFields`, {
      name: choiceName,
      type: choiceType,
      value: choiceValue,
    });
  }

  updateEmbeddedField(
    embeddedFieldId: number,
    choiceName: string,
    choiceType: number,
    choiceValue: string | number | boolean | Date | null,
  ): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/embeddedFields/${embeddedFieldId}`, {
      idobject: embeddedFieldId,
      name: choiceName,
      type: choiceType,
      value: choiceValue,
    });
  }

  /* embedded field choice - end*/
}
